import {
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, Subject } from 'rxjs';
import { ToasterService, ToasterConfig } from 'angular2-toaster';
import { CookieService } from "angular2-cookie/core";

import { FormatUtilities } from '../utilities/format-utilities';
import { LoadingSpinnerService } from "../services/loading-spinner.service";
import { PageTitleService } from "../services/page-title.service";
import { CurrentUserService } from "../services/current-user.service";
import { QuoteInfoService } from "../services/quote-info.service";
import { QuoteApprovalService } from "../services/quote-approval.service";
import { PagerService } from "../services/pager.service";
import { BrowserWidthService } from "../services/browser-width.service";
import { QuoteApprovalSearchPipe } from "../pipes/quote-approval-search.pipe";
import { ModalDialogService } from '../reusable-components/modal-dialog/modal-dialog.service';
import { QuoteService } from '../services/quote.service';
import { CurrentUser } from '../model/current-user';
import { Constants } from "../model/constants";
import { PagerInfo } from '../model/pager-info';
import { Facility } from '../model/facility';
import { Quote } from '../model/quote';
import { Retailer } from '../model/retailer';

import { HttpResponseService } from '../services/httpresponse-service';

@Component({
    selector: 'my-quote-approvals',
    template: require('./quote-approvals.component.html'),
    styles: [require('./quote-approvals.component.scss')]
})
export class QuoteApprovalsComponent implements OnInit, AfterViewInit, OnDestroy {

    userId: number;
    chosenPlantId: number = 0;
    chosenRetailerId: number = 0;
    plantNumber: number = 0;
    height: number;

    retailerNumber: string = '';
    searchTerm: string = '';
    filterPlantsButton: string;
    filterRetailersButton: string = 'All Retailers';
    filterStatusButton: string = 'All Statuses';
    actionsButton: string = 'Actions';
    mchBaseUrl: string;
    quoteStatuses: string[] = ['Not Submitted', 'Pending Approval', 'Declined', 'Approved'];

    displayNoMatches: boolean = false;
    viewQuoteModal: boolean = false;

    search: Observable<any>;
    config: ToasterConfig = new ToasterConfig({
        positionClass: this.browserWidthService.getDisplayMode().width.innerWidth < 769 ? 'toast-bottom-full-width' : 'toast-bottom-right'
    });
    pager: PagerInfo;
    currentUser: CurrentUser;
    facilities: Facility[];
    retailers: Retailer[];
    quotes: Quote[];
    pagedQuotes: Quote[];
    selectedQuote: Quote;

	subscription: Subscription = new Subscription();

	// refactor changes
	selectedStatus: number = 1;
	chosenPlantNumber: number = 0;
	searchText: string;
	searchTextChanged: Subject<string> = new Subject<string>();
	readonly PENDING_STATUS = 1;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public spinner: LoadingSpinnerService,
        public pageTitleService: PageTitleService,
        public toasterService: ToasterService,
        public modalDialogService: ModalDialogService,
        public currentUserService: CurrentUserService,
        public formatUtilities: FormatUtilities,
        public quoteInfoService: QuoteInfoService,
        public quoteApprovalService: QuoteApprovalService,
        public pagerService: PagerService,
        public quoteApprovalSearchPipe: QuoteApprovalSearchPipe,
        public cookieService: CookieService,
        public browserWidthService: BrowserWidthService,
        public quoteService: QuoteService,
        public httpResponseService: HttpResponseService

    ) {
        const currentUserSub = this.currentUserService.currentUser$.subscribe(x => {
            if (x !== undefined && x !== null) {
                if (x.cmhUserId !== this.userId) {
                    this.userId = x.cmhUserId;
                    this.currentUser = x;
                    this.pageTitleService.pageTitle.next({ title: Constants.CmhConnectionTitle, subTitle: 'Current User ' + this.userId });
                }
            }
        });
        this.subscription.add(currentUserSub);
        this.mchBaseUrl = this.cookieService.get('mchBaseUrl');
        const windowResizeSub = Observable.fromEvent(window, 'resize')
            .subscribe(() => {
                this.height = document.getElementById('content-wrapper').scrollHeight + 114;
            });
		this.subscription.add(windowResizeSub);

		const oaSearchTextChangeSub = this.searchTextChanged
			.debounceTime(500)              // wait 500ms after the last event before emitting last event
			.distinctUntilChanged()         // only emit if value is different from previous value
			.subscribe(searchText => {
				this.searchTerm = searchText !== undefined && searchText !== null ? searchText : '';
				this.applyfiltersLoadQuoteApprovals(1);
			});
		this.subscription.add(oaSearchTextChangeSub);

    }

    ngOnInit() {
        if (this.currentUser !== undefined && this.currentUser !== null
            && this.currentUser.availableFacilities !== undefined && this.currentUser.availableFacilities !== null && this.currentUser.availableFacilities.length > 0) {
            this.spinner.showSpinner();
            this.facilities = new Array<Facility>();
            this.currentUser.availableFacilities.forEach((plant) => {
                let facility = new Facility();
                facility.PlantNumber = Number(plant.plantNumber);
                facility.PlantDescription = plant.name;
                this.facilities.push(facility);
            });

            this.quoteApprovalService.getPlantsWithQuotes(this.facilities, Constants.QuoteApprovalStatus.PENDING_APPROVAL)
                .subscribe(x => {
                    if (x !== undefined && x !== null && x.length > 0) {
                        if (this.facilities !== undefined && this.facilities !== null && this.facilities.length > 0) {
                            x.forEach(plant => {
                                if (this.facilities.filter(fac => fac.PlantNumber === plant.PlantNumber).length > 0) {
                                    plant.PlantDescription = this.facilities.filter(fac => Number(fac.PlantNumber) === Number(plant.PlantNumber))[0].PlantDescription
                                }

                            });
                        }
                        this.facilities = x;
                        this.sortPlants();
                        this.plantNumber = (this.facilities !== undefined && this.facilities !== null && this.facilities.length > 0)
                            ? this.facilities[0].PlantNumber : this.currentUser.availableFacilities[0].plantNumber;
                        this.filterPlantsButton = (this.facilities !== undefined && this.facilities !== null && this.facilities.length > 0)
                            ? this.facilities[0].PlantDescription : this.currentUser.availableFacilities[0].name;
						this.applyfiltersLoadQuoteApprovals(1);
                    } else {
                        this.pager = new PagerInfo();
                        this.displayNoMatches = true;
                        this.setPage(1, new Array<Quote>());
                    }
                });
        } else {
            this.pager = new PagerInfo();
            this.displayNoMatches = true;
            this.setPage(1, new Array<Quote>());
        }
    }

    ngAfterViewInit() {
        this.displayNoMatches = false;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    /// Sorts the Quotes
    sortQuotes(quotes: Quote[]): Quote[] {
        if (quotes !== undefined && quotes !== null && quotes.length > 1) {
            return quotes.sort((a, b) => {
                if (a.iseriesQuoteNumber > 0 && a.QuoteStatusesID > 0) {
                    a.quoteId = a.iseriesQuoteNumber;
                };
                if (b.iseriesQuoteNumber > 0 && b.QuoteStatusesID > 0) {
                    b.quoteId = b.iseriesQuoteNumber;
                };
                return a.quoteId - b.quoteId;
            });
        }
        return quotes;
    }

    /// Sorts the Plants
    sortPlants() {
        if (this.facilities !== undefined && this.facilities !== null && this.facilities.length > 1) {
            this.facilities.sort((a, b) => {
                return a.PlantNumber - b.PlantNumber;
            });
        }
    }

    /// Sorts the Retailers
    sortRetailers() {
        if (this.retailers !== undefined && this.retailers !== null && this.retailers.length > 1) {
            this.retailers.sort((a, b) => {
                if (a.RetailerName < b.RetailerName) { return -1; }
                if (a.RetailerName > b.RetailerName) { return -1; }
                return 0;
            });
        }
    }

    /// Selects all Retailers
    allRetailers() {
        this.spinner.showSpinner();
		this.filterRetailersButton = 'All Retailers';
		this.retailerNumber = undefined;
		this.filterStatusButton = 'Pending Approval';
		this.selectedStatus = this.PENDING_STATUS;
		this.applyfiltersLoadQuoteApprovals(1);
    }

    /// Plant is changed
    plantChange(plantNumber: number) {
        this.spinner.showSpinner();
		this.chosenPlantId = plantNumber;
		this.plantNumber = plantNumber;
		this.filterPlantsButton = this.facilities.find(x => x.PlantNumber === plantNumber).PlantDescription;

		this.filterRetailersButton = 'All Retailers';
		this.retailerNumber = undefined;
		this.filterStatusButton = 'Pending Approval';
		this.selectedStatus = this.PENDING_STATUS;
		this.applyfiltersLoadQuoteApprovals(1);

    }

    /// Retailer is changed
    retailerChange(retailerNumber: string) {
        this.spinner.showSpinner();
        this.filterRetailersButton = this.retailers.find(x => x.RetailerNumber === retailerNumber).RetailerName;
		this.retailerNumber = retailerNumber;
		this.filterStatusButton = 'Pending Approval';
		this.selectedStatus = this.PENDING_STATUS;
		this.applyfiltersLoadQuoteApprovals(1);

    }

    /// Selects all Statuses
    allStatuses() {
        this.spinner.showSpinner();
        this.filterStatusButton = 'All Statuses';
		this.selectedStatus = -1;
		this.applyfiltersLoadQuoteApprovals(1);

    }

    /// Status is changed
    statusChange(stat: string) {
		this.spinner.showSpinner();
		this.selectedStatus = (stat.toUpperCase().includes('NOT SUBMITTED')) ? 0 :
			(stat.toUpperCase().includes('PENDING APPROVAL')) ? 1 :
			(stat.toUpperCase().includes('DECLINED')) ? 2 :
			(stat.toUpperCase().includes('APPROVED')) ? 3 : -1 ;

        this.filterStatusButton = stat;
		this.applyfiltersLoadQuoteApprovals(1);

    }

    /// Resets the pages to a new list of quotes
    setPage(page: number, quotes: Quote[]) {
        this.spinner.showSpinner();
        if (quotes !== undefined && quotes !== null && quotes.length > 0) {
            this.displayNoMatches = false;
			this.pagedQuotes = quotes;
        } else {
            this.displayNoMatches = true;
            this.pager = this.pagerService.getPager(new Array<Quote>(), page, 21);
            this.pagedQuotes = new Array<Quote>();
        }
		this.spinner.hideSpinner();
    }


    /// Navigates to the next page of quotes
    navigatePages(page: number) {
		this.applyfiltersLoadQuoteApprovals(page);
    }

    /// Displays a Confirmation Modal
    viewQuote(item: Quote) {
        if (item !== undefined && item !== null && item.quoteId !== undefined && item.quoteId !== null && item.quoteId !== 0) {
            this.spinner.showSpinner();
            this.height = document.getElementById('content-wrapper').scrollHeight + 114;
            this.selectedQuote = item;
            this.quoteApprovalService.validateQuote(item.quoteId, this.currentUser.fullName).map(x => {
                if (x !== undefined && x !== null && !x.ValidQuote) {
                    this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(true);
                    this.quoteApprovalService.invalidQuote$.next(x);
                } else {
                    this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(false);
                    this.viewQuoteModal = true;
                    this.browserWidthService.modalActive$.next(true);
                }
            }).subscribe(() => {
                this.spinner.hideSpinner();
            });
        }
    }

    createiSeriesOrder(item: Quote) {
        if (item !== undefined && item !== null && item.quoteId !== undefined && item.quoteId !== null && item.quoteId !== 0) {
            this.spinner.showSpinner();
            this.quoteService.createiSeriesOrder(item.quoteId)
                .subscribe(
                    newOrderNumber => { console.log(newOrderNumber); },
                    error => { this.spinner.hideSpinner(); this.httpResponseService.httpErrorResponse$.next(error); },
                    () => { this.spinner.hideSpinner(); });
        }
    }

    /// Navigates to the QuoteSummary Page for that Quote
    navQuoteSummary() {
        this.viewQuoteModal = false;
        this.browserWidthService.modalActive$.next(false);
        window.location.href = `${this.mchBaseUrl}/${([Constants.QuoteSummaryUrl.replace('#quoteid#', this.selectedQuote.quoteId.toString())])}`;
    }

    /// Gets the status for the UI
    getStatus(quoteStatusesID: number): string {
        if (quoteStatusesID == 0) { return 'Not Submitted'; }
        if (quoteStatusesID == 1) { return 'Pending Approval'; }
        if (quoteStatusesID == 2) { return 'Declined'; }
        if (quoteStatusesID == 3) { return 'Approved'; }
	}

	loadQuoteApprovals(plantNumber: number, pageRequested: number, retailerNumber: string = undefined, quoteStatusId: number = -1, searchString: string = undefined) {
		this.spinner.showSpinner();
		this.quoteApprovalService.getQuoteApprovalsWithPaging(plantNumber, pageRequested, undefined, retailerNumber, quoteStatusId, searchString)
			.subscribe(
			((x) => {
				this.pager = new PagerInfo();
				let qm = x;
				this.quotes = this.quoteApprovalService.getQuotesCache;
				this.retailers = this.quoteApprovalService.getRetailersCache;
				this.pager.totalPages = x.TotalPageCount;
				this.pager.currentPage = x.CurrentPage;
				this.sortRetailers();
				this.spinner.hideSpinner();
			}),
			(error => {
				this.quotes = new Array<Quote>();
				this.retailers = new Array<Retailer>();
				this.spinner.hideSpinner();
			}),
			(() => {
				if (this.quotes !== undefined && this.quotes !== null) {
					if (this.quotes.length > 0) {
						this.pager.currentPage = this.quotes[0].CurrentPage;
						this.pager.totalPages = this.quotes[0].TotalPageCount;
					}
					this.setPage(1, this.quotes);
				} else {
					this.displayNoMatches = true;
					this.setPage(1, new Array<Quote>());
				}
				this.spinner.hideSpinner();
			}));
	}

	applyfiltersLoadQuoteApprovals(pageRequested: number) {
		let plantNumber = this.plantNumber;
		let retailerNumber = (this.retailerNumber === "") ? undefined :this.retailerNumber;
		let quoteStatusId = this.selectedStatus;
		if (this.selectedStatus === this.PENDING_STATUS) { this.filterStatusButton = 'Pending Approval'; }

		let searchString = undefined;
		if (this.searchTerm !== undefined && this.searchTerm !== null) {
			if (this.searchTerm.trim().length > 0) {
				searchString = this.searchTerm;
			}
		}
		this.loadQuoteApprovals(plantNumber, pageRequested, retailerNumber, quoteStatusId, searchString);
	}

	searchFor(text: string) {
		this.searchTextChanged.next(text);
	}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/quote-approvals/quote-approvals.component.ts